import DownloadsFooter from "./DownloadsFooter";

export default DownloadsFooter;
